import React, { useState } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { cn } from '../../../lib/utils';
import { Card, CardContent } from '../../../components/ui';

// Import components (similar structure to approval-requests)
import ApprovalTemplateHeader from './components/ApprovalTemplateHeader';
import ApprovalTemplateStatusSection from './components/ApprovalTemplateStatusSection';
import ApprovalTemplateActions from './components/ApprovalTemplateActions';
import ApprovalTemplateDetails from './components/ApprovalTemplateDetails';
import ApprovalTemplateSteps from './components/ApprovalTemplateSteps';
import EmptyState from './components/EmptyState';

const CustomApprovalTemplatesSplitView = ({ 
  isOpen, 
  selectedRecord, 
  selectedRecordFiles, 
  config, 
  fields, 
  labels, 
  onClose,
  onEdit,
  onView
}) => {
  const { theme } = useTheme();
  const [actionLoading, setActionLoading] = useState(false);

  if (!isOpen) return null;

  const handleAction = async (action, data = {}) => {
    setActionLoading(true);
    try {
      switch (action) {
        case 'edit':
          if (onEdit && selectedRecord) {
            onEdit(selectedRecord);
          }
          setActionLoading(false);
          return;
        case 'view':
          if (onView && selectedRecord) {
            onView(selectedRecord);
          }
          break;
        default:
          console.log('Approval template action:', action, data);
      }
    } catch (error) {
      console.error(`Error performing ${action}:`, error);
    } finally {
      setActionLoading(false);
    }
  };

  return (
    <div 
      className={cn("hidden lg:block min-h-0 h-full pb-2")}
      style={{ width: config.ui?.drawerWidth || '420px' }}
    >
      <Card className={cn("min-h-0 h-full flex flex-col", theme.shadow.lg)}>
        {/* Header */}
        <ApprovalTemplateHeader 
          selectedRecord={selectedRecord} 
          onClose={onClose} 
        />
        
        <CardContent className="flex-1 overflow-auto p-3 space-y-3">
          {selectedRecord ? (
            <>
              {/* Status and Key Information */}
              <ApprovalTemplateStatusSection selectedRecord={selectedRecord} />

              {/* Action Panel */}
              <div className="space-y-4">
                <ApprovalTemplateActions 
                  selectedRecord={selectedRecord}
                  onHandleAction={handleAction}
                />

                {/* Details Section */}
                <ApprovalTemplateDetails selectedRecord={selectedRecord} />

                {/* Steps Section */}
                <ApprovalTemplateSteps selectedRecord={selectedRecord} />
              </div>
            </>
          ) : (
            <EmptyState />
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default CustomApprovalTemplatesSplitView;

